export const MEMBERSHIP_FEE_TREATMENTS = ['included', 'separate'];
export const REGISTRATION_FEE_TREATMENTS = ['included', 'separate'];

const getSettingsSource = (subProductOrSettings) => {
  if (!subProductOrSettings || typeof subProductOrSettings !== 'object') {
    return {};
  }

  if (subProductOrSettings.settings && typeof subProductOrSettings.settings === 'object') {
    return subProductOrSettings.settings;
  }

  return subProductOrSettings;
};

export const resolveMembershipFeeTreatment = (subProductOrSettings) => {
  const settings = getSettingsSource(subProductOrSettings);
  if (settings.includeMembershipFeeByDefault === true) {
    return 'included';
  }
  if (settings.includeMembershipFeeByDefault === false) {
    return 'separate';
  }

  if (MEMBERSHIP_FEE_TREATMENTS.includes(settings.membershipFeeTreatment)) {
    return settings.membershipFeeTreatment;
  }

  return 'separate';
};

export const resolveRegistrationFeeTreatment = (subProductOrSettings) => {
  const settings = getSettingsSource(subProductOrSettings);
  if (settings.excludeRegistrationFeeByDefault === true) {
    return 'separate';
  }
  if (settings.excludeRegistrationFeeByDefault === false) {
    return 'included';
  }

  if (REGISTRATION_FEE_TREATMENTS.includes(settings.registrationFeeTreatment)) {
    return settings.registrationFeeTreatment;
  }

  return 'separate';
};

export const isMembershipFeeIncluded = (subProductOrSettings) => (
  resolveMembershipFeeTreatment(subProductOrSettings) === 'included'
);

export const isRegistrationFeeIncluded = (subProductOrSettings) => (
  resolveRegistrationFeeTreatment(subProductOrSettings) === 'included'
);

export const isInternationalPaymentEnabled = (subProductOrSettings) => (
  getSettingsSource(subProductOrSettings).internationalPaymentEnabled === true
);

export const resolveInternationalPaymentFeeContext = (subProduct, { isModuleBased = true } = {}) => {
  const enabled = isModuleBased && isInternationalPaymentEnabled(subProduct);
  const configuredAmount = enabled ? Number(subProduct?.internationalPaymentFee?.amount) || 0 : 0;
  const payableAmount = configuredAmount > 0 ? configuredAmount : 0;
  const currency = subProduct?.internationalPaymentFee?.currency || 'LKR';

  return {
    enabled: enabled && payableAmount > 0,
    configuredAmount,
    amount: configuredAmount,
    currency,
    payableAmount
  };
};

export const resolveRegistrationFeeContext = (subProduct, studentType = 'external') => {
  const isInternalStudent = studentType === 'internal';
  const catalogRegistrationFeeAmount = Number(subProduct?.registrationFee?.amount) || 0;
  const registrationFeeIncludedInCourse = !isInternalStudent
    && isRegistrationFeeIncluded(subProduct)
    && catalogRegistrationFeeAmount > 0;
  const registrationFeeAmount = isInternalStudent
    ? 0
    : (registrationFeeIncludedInCourse ? 0 : catalogRegistrationFeeAmount);
  const registrationFeeCurrency = subProduct?.registrationFee?.currency || subProduct?.baseFee?.currency || 'LKR';

  return {
    configuredRegistrationFeeAmount: catalogRegistrationFeeAmount,
    catalogRegistrationFeeAmount,
    registrationFeeIncludedInCourse,
    registrationFeeAmount,
    registrationFeeCurrency,
    waivedForInternalStudent: isInternalStudent && catalogRegistrationFeeAmount > 0
  };
};

export const normalizeSubProductFeeSettings = (settings = {}) => {
  const membershipFeeTreatment = resolveMembershipFeeTreatment(settings);
  const registrationFeeTreatment = resolveRegistrationFeeTreatment(settings);

  return {
    ...settings,
    membershipFeeTreatment,
    registrationFeeTreatment,
    includeMembershipFeeByDefault: membershipFeeTreatment === 'included',
    excludeRegistrationFeeByDefault: registrationFeeTreatment !== 'included',
    internationalPaymentEnabled: settings.internationalPaymentEnabled === true
  };
};